import { useRouter } from 'next/router';

export default function useIsPrismaPage() {
    const router = useRouter();
    // Usar una ruta estable entre SSR/cliente para evitar desajustes de hidratación
    // En SSR confiamos en pathname; en cliente preferimos asPath si está disponible
    const rawPath = typeof window === 'undefined' ? router.pathname : router.asPath || router.pathname;
    const normalized = (rawPath || '').replace(/\/$/, '');

    // Detectar si estamos en cualquier ruta de prisma
    return normalized.startsWith('/prisma') || normalized.startsWith('/en/prisma');
}
